import { useRef } from 'react';
import usePrefersReducedMotion from '../hooks/usePrefersReducedMotion';
import usePortalTrace from '../hooks/usePortalTrace';
import portalArt from '../assets/img/portal-o.webp';
import { MARK_OVERHANG } from '../utils/portalWordmark';

/**
 * PortalMark — the spinning portal alone, for phones (TopBar < 640px), loading
 * states, and anywhere the word won't fit. It swells on the same cycle as the
 * word's trace (hooks/usePortalTrace), and holds still under reduced motion.
 *
 * `size` is the visible box; the art overhangs it by 12% per side so the ring,
 * not the faint tails, fills the box. Give the parent a little room (or
 * overflow: visible).
 */
export default function PortalMark({ size = 40, className = '', still, speed = 1 }) {
  const reduced = usePrefersReducedMotion();
  const frozen = still ?? reduced;
  const root = useRef(null);
  usePortalTrace(root, { reduced: frozen, speed });

  return (
    <span
      ref={root}
      role="img"
      aria-label="Portal"
      className={className}
      style={{ position: 'relative', display: 'inline-block', flex: '0 0 auto', width: size, height: size }}
    >
      <span data-pulse style={{ position: 'absolute', inset: `${-MARK_OVERHANG * 100}%`, display: 'block' }}>
        <img
          src={portalArt}
          alt=""
          draggable="false"
          className={frozen ? undefined : 'pr-portal-spin'}
          style={{ display: 'block', width: '100%', height: '100%' }}
        />
      </span>
    </span>
  );
}
